import FormHistory from 'modules/FormHistory';
import React from 'react';

type Props = {
  source: any;
  profileUuid: string;
  contact: any;
};

const SourceOfFundHistory = ({ source, profileUuid, contact }: Props) => {
  if (!source?.form) {
    return <div className="s-left-s s-top-md">No form found</div>;
  }
  return (
    <>
      <FormHistory
        formKey={source?.form?.key}
        contactName={contact.name}
        profileUuid={profileUuid}
        options={{ sourceOfFundsUuid: source.uuid }}
        type="sof"
        canEdit={false}
      />
    </>
  );
};

export default SourceOfFundHistory;
